import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/skin/c/tiger-machine-panel.svg'
import _imports_1 from '@/assets/images/skin/c/tiger-machine-panel-light-1.svg'
import _imports_2 from '@/assets/images/skin/c/tiger-machine-panel-light-2.svg'
import _imports_3 from '@/assets/images/skin/c/tiger-machine-handle.svg'
import _imports_4 from '@/assets/images/skin/c/tiger-machine-box.svg'
import _imports_5 from '@/assets/images/skin/c/lottery-1.svg'
import _imports_6 from '@/assets/images/skin/c/lottery-2.svg'
import _imports_7 from '@/assets/images/skin/c/lottery-3.svg'
import _imports_8 from '@/assets/images/skin/c/lottery-4.svg'


const _withScopeId = n => (_pushScopeId("data-v-3bf11098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tiger-machine" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"tiger-machine-panel\" data-v-3bf11098><img src=\"" + _imports_0 + "\" alt=\"\" data-v-3bf11098></div><div class=\"tiger-machine-panel-light\" data-v-3bf11098><img src=\"" + _imports_1 + "\" alt=\"\" data-v-3bf11098><img src=\"" + _imports_2 + "\" alt=\"\" data-v-3bf11098></div>", 2)
const _hoisted_4 = { class: "tiger-machine-handle-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tiger-machine-handle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tiger-machine-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "tiger-machine-lottery-panel" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tiger_machine_lottery = _resolveComponent("tiger-machine-lottery")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tiger-machine-panel-container",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.lotteryRandom && _ctx.lotteryRandom(...args)))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          class: _normalizeClass(['tiger-machine-box-container', _ctx.lotterySwitch && 'active'])
        }, _hoisted_7, 2)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_tiger_machine_lottery, {
          class: "lottery-1",
          lottery: _ctx.lottery
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        }, 8, ["lottery"]),
        _createVNode(_component_tiger_machine_lottery, {
          class: "lottery-2",
          lottery: _ctx.lottery,
          delay: 400
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        }, 8, ["lottery"]),
        _createVNode(_component_tiger_machine_lottery, {
          class: "lottery-3",
          lottery: _ctx.lottery,
          delay: 800
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }, 8, ["lottery"]),
        _createVNode(_component_tiger_machine_lottery, {
          class: "lottery-4",
          lottery: _ctx.lottery,
          delay: 1200,
          onFinish: _ctx.closeLotterySwitch
        }, {
          default: _withCtx(() => [
            _hoisted_15,
            _hoisted_16
          ]),
          _: 1
        }, 8, ["lottery", "onFinish"])
      ])
    ])
  ]))
}